import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

const LOGO_BASE = `${process.env.PUBLIC_URL}/workbench/Workbench Logos`;

export default function WorkbenchType() {
  const navigate = useNavigate();
  const { vertical_id } = useParams();
  const location = useLocation();

  const isPersonalActive = location.pathname.endsWith('/workbench/personal');
  const isVerticalActive = location.pathname.endsWith('/workbench/vertical');

  const handlePersonalClick = () => {
    if (vertical_id) {
      navigate(`/vertical/${vertical_id}/workbench/personal`);
    } else {
      navigate('/workbench/personal');
    }
  };

  const handleVerticalClick = () => {
    if (vertical_id) {
      navigate(`/vertical/${vertical_id}/workbench/vertical`);
    }
  };

  const personalLogo = `${LOGO_BASE}/Personal Dashboard Logo - ${
    isPersonalActive ? 'Selected' : 'Unselected'
  }.svg`;
  const verticalLogo = `${LOGO_BASE}/Vertical Dashboard Logo - ${
    isVerticalActive ? 'Selected' : 'Unselected'
  }.svg`;

  const buttonSx = (active, position) => ({
    textTransform: 'none',
    fontWeight: active ? 600 : 500,
    px: 2,
    py: 1,
    border: '1px solid',
    borderColor: active ? 'primary.main' : 'rgba(0, 0, 0, 0.23)',
    backgroundColor: active ? '#eaf1fb' : '#fff',
    color: active ? 'primary.main' : 'text.secondary',
    borderRadius: 0,
    ...(position === 'left' && {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
    }),
    ...(position === 'right' && {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
      marginLeft: '-1px',
    }),
    zIndex: active ? 2 : 0,
    '&:hover': {
      backgroundColor: active ? '#dde9f8' : '#f5f7fa',
      borderColor: active ? 'primary.main' : 'rgba(0, 0, 0, 0.23)',
      zIndex: active ? 3 : 1,
    },
    '&.Mui-disabled': {
      border: '1px solid',
      borderColor: 'rgba(0, 0, 0, 0.23)',
      backgroundColor: '#fff',
      color: 'text.secondary',
      cursor: 'not-allowed',
      pointerEvents: 'auto',
    },
  });

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        '& > *': {
          m: 1,
        },
      }}
    >
      <Box sx={{ display: 'inline-flex' }}>
        <Button
          onClick={handlePersonalClick}
          sx={buttonSx(isPersonalActive, 'left')}
          startIcon={<img src={personalLogo} alt="" style={{ width: 18, height: 18 }} />}
        >
          Personal Workbench
        </Button>
        <Button
          onClick={handleVerticalClick}
          disabled={!vertical_id}
          sx={buttonSx(isVerticalActive, 'right')}
          startIcon={<img src={verticalLogo} alt="" style={{ width: 18, height: 18 }} />}
        >
          Vertical Workbench
        </Button>
      </Box>
    </Box>
  );
}
